import * as React from "react";
import {PageTitle} from "../../components/TitleBar/PageTitle";
import RefinitivContainer from "./RefinitivContainer";
import RefinitivTable from "../../components/Refinitiv/Table/RefinitivTable";

interface DeliveriesProps {
    mode: 'recentDeliveries' | 'allDeliveries'
}

export default (props: DeliveriesProps) => {
    let title: string = "Recent Deliveries";
    if (props.mode === "allDeliveries") {
        title = "All Deliveries";
    }

    return (
        <RefinitivContainer>
            <PageTitle pageTitle={title}/>
            <RefinitivTable key={props.mode} mode={props.mode} />
        </RefinitivContainer>
    )
}